<script setup lang="ts">
import { Link, router } from "@inertiajs/vue3";
import JetApplicationMark from "@/Jetstream/ApplicationMark.vue";

const logout = () => {
    router.post(route("logout"));
};
</script>

<template>
    <div class="bg-iron-50 min-h-screen">
        <header class="border-iron-200 bg-white border-b">
            <div
                class="max-w-6xl px-6 py-4 mx-auto flex items-center justify-between"
            >
                <Link
                    :href="route('reality.dashboard')"
                    class="text-iron-900"
                    aria-label="Reality Zaptime"
                >
                    <JetApplicationMark class="h-8 block w-auto" />
                </Link>

                <nav class="gap-4 text-sm font-medium flex items-center">
                    <Link
                        :href="route('reality.dashboard')"
                        class="text-iron-700 hover:text-iron-900"
                    >
                        {{ $t("reality.nav.dashboard") }}
                    </Link>
                    <button
                        type="button"
                        class="text-iron-700 hover:text-iron-900"
                        @click="logout"
                    >
                        {{ $t("reality.nav.logout") }}
                    </button>
                </nav>
            </div>
        </header>

        <main>
            <slot />
        </main>
    </div>
</template>
